/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import React from 'react';
import { WhatsappIcon } from '../../icons/whatsapIcon';

interface WhatsAppButtonBaseProps {
  text?: string;
  iconSize?: number;
  className?: string;
  trackClick?: () => void;
  createLink?: () => string;
}

interface WhatsAppButtonProps extends WhatsAppButtonBaseProps {
  type: 'button';
  onClick: () => void;
}

type ComponentProps = WhatsAppButtonProps;

export const WhatsAppButton: React.FC<ComponentProps> = ({
  iconSize = 28,
  className = '',
  text,
  trackClick,
  // todo: create this function
  // eslint-disable-next-line unused-imports/no-unused-vars
  createLink,
  ...props
}) => {
  const baseStyles = classNames(
    'flex items-center justify-center gap-1 rounded-lg',
    'outline-none bg-[#25D366] text-[#111B21]',
    className,
  );

  const renderContent = () => (
    <div className="flex items-center justify-center gap-1">
      {text && <p className="font-semibold text-base">{text}</p>}
      <WhatsappIcon size={iconSize} color="#111B21" />
    </div>
  );

  return (
    <button
      type="button"
      onClick={() => {
        props.onClick();
        trackClick?.();
      }}
      className={baseStyles}
      style={{ height: '36px' }}
    >
      {renderContent()}
    </button>
  );
};
